module.exports = __webpack_public_path__ + "static/media/language-solid.6469c193.svg";